
interface MetaData {
    title: string;
    description: string;
    robots?: string;
    canonical?: string;
    og?: {
        locale?: string,
        type?: string,
        title?: string,
        description?: string,
        url?: string,
        site_name?: string,
        updated_time?: string,
        image?: string,
        image_secure_url?: string,
        image_width?: number,
        image_height?: number,
        image_alt?: string,
        image_type?: string,
        video?: string,
        video_duration?: number,
        video_upload_date?: string,
        video_allow_embed?: boolean,
    };
    twitter?: {
        card?: string,
        title?: string,
        description?: string,
        image?: string,
    };
}

interface Step {
    title: string;
    desc: string;
    icon: string;
}

interface ProcedureSteps {
    heading: string;
    para: string;
    steps: Step[];
}

interface ListItem {
    title: string;
    desc: string;
    icon: string;
}

interface ListSection {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface ingredients {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface FAQItem {
    question: string;
    answer: string;
}

interface FAQSection {
    heading?: string;
    subheading?: string;
    items: FAQItem[];
}

interface HeroSection {
    title: string;
    subtitle: string;
    description: string;
}

interface HowItWorks {
    title: string;
    description: string;
}

interface TreatmentArea {
    ar: string;
    title: string;
    image: string;
}

interface LanguageContent {
    url?: string; // Added url property
    meta: MetaData;
    breadcrumbs: string[];
    hero: HeroSection;
    howItWorks: HowItWorks;
    procedureSteps: ProcedureSteps;
    benefits: ListSection;
    eligibility: ListSection;
    preparationTips: ListSection;
    results: ListSection;
    // aftercareTips: ListSection;
    faqData: FAQSection;
    ingredients: ingredients;
    // treatmentAreas1: TreatmentArea[];
    // treatmentAreas2: TreatmentArea[];
}

interface SharedData {
    images: {
        main: string,
        beforeAfter: string[] | any,
        introductionImage?: string,
    };
    product: {
        id: number,
        title: string,
        price: number,
        description: string,
    };
}

export const liverdetox: {
    en: LanguageContent,
    ar: LanguageContent,
    shared: SharedData,
} =
{
    "en": {
        "url": "liver-detox-iv-drip",
        "meta": {
            "title": "Liver Detox IV Drip in Dubai - Elite Body Home",
            "description": "Support your liver's natural detoxification process with our Liver Detox IV Drip in Dubai. This specialized therapy delivers essential nutrients directly to your bloodstream for optimal liver function and overall wellness.",
            "robots": "follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large",
            "canonical": "https://elitebodyhome.com/services/liver-detox-iv-drip-in-dubai/",
            "og": {
                "locale": "en_US",
                "type": "article",
                "title": "Liver Detox IV Drip in Dubai - Elite Body Home",
                "description": "Support your liver's natural detoxification process with our Liver Detox IV Drip in Dubai. This specialized therapy delivers essential nutrients directly to your bloodstream.",
                "url": "https://elitebodyhome.com/services/liver-detox-iv-drip-in-dubai/",
                "site_name": "elitebodyhome.com",
                "updated_time": "2025-01-23T09:27:39+00:00",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/liver-detox-iv.jpg",
                "image_secure_url": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/liver-detox-iv.jpg",
                "image_width": 1254,
                "image_height": 700,
                "image_alt": "Liver Detox IV Drip Treatment in Dubai",
                "image_type": "image/jpeg"
            },
            "twitter": {
                "card": "summary_large_image",
                "title": "Liver Detox IV Drip in Dubai - Elite Body Home",
                "description": "Support your liver's natural detoxification process with our Liver Detox IV Drip in Dubai. This specialized therapy delivers essential nutrients directly to your bloodstream.",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/liver-detox-iv.jpg"
            }
        },
        "breadcrumbs": ["Home", "Services", "Liver Detox IV Drip"],
        "hero": {
            "title": "Liver Detox IV Drip in Dubai",
            "subtitle": "Cleanse, Revitalize, and Restore!",
            "description": "The liver is key to detoxifying the body, processing nutrients, and breaking down toxins. However, with today's busy schedules, unhealthy diets and constant exposure to environmental toxins, our liver can easily get overworked. Our Liver Detox IV therapy is formulated to aid the liver's natural detoxification process, replenishing nutrients and promoting optimal liver function for improved health and vitality."
        },
        "howItWorks": {
            "title": "What is Liver Detox IV Therapy?",
            "description": "Liver Detox IV therapy is a specialized treatment designed to support your liver's natural detoxification processes. The IV solution contains a powerful blend of B-complex vitamins, minerals (magnesium, zinc), and potent antioxidants like glutathione that work synergistically to enhance liver function, promote toxin elimination, and restore optimal health."
        },
        "procedureSteps": {
            "heading": "Liver Detox IV Drip Procedure",
            "para": "This simple outpatient procedure delivers detoxifying nutrients directly into your bloodstream for maximum absorption and effectiveness.",
            "steps": [
                {
                    "title": "Consultation",
                    "desc": "Our healthcare provider reviews your medical history and specific liver health needs to customize your treatment.",
                    "icon": "fa-solid fa-comment-medical"
                },
                {
                    "title": "Preparation",
                    "desc": "The IV solution is prepared with a customized blend of vitamins, minerals and antioxidants tailored to your needs.",
                    "icon": "fa-solid fa-flask"
                },
                {
                    "title": "Administration",
                    "desc": "A small needle is inserted into your vein to deliver the detoxifying solution directly into your bloodstream.",
                    "icon": "fa-solid fa-syringe"
                },
                {
                    "title": "Monitoring",
                    "desc": "Your vitals and comfort are monitored throughout the 30-60 minute session by our medical professionals.",
                    "icon": "fa-solid fa-heart-pulse"
                }
            ]
        },
        "benefits": {
            "heading": "Benefits of Liver Detox IV Drip",
            "subheading": "Experience comprehensive liver support and detoxification",
            "para": "Our Liver Detox IV therapy promotes overall wellness by enhancing your liver's natural filtration of toxins and providing essential nutrients.",
            "items": [
                {
                    "title": "Enhanced Detoxification",
                    "desc": "Helps eliminate accumulated toxins from the liver, improving its filtration efficiency.",
                    "icon": "fa-solid fa-recycle"
                },
                {
                    "title": "Increased Energy",
                    "desc": "Optimizes liver function for better energy production, reducing fatigue and lethargy.",
                    "icon": "fa-solid fa-bolt"
                },
                {
                    "title": "Clearer Skin",
                    "desc": "Reduces inflammation and free radical damage that can affect skin health.",
                    "icon": "fa-solid fa-spa"
                },
                {
                    "title": "Reduced Inflammation",
                    "desc": "Lowers toxin exposure that contributes to chronic inflammation throughout the body.",
                    "icon": "fa-solid fa-fire-extinguisher"
                }
            ]
        },
        "ingredients": {
            "heading": "Key Ingredients",
            "subheading": "Powerful nutrients for liver support and detoxification",
            "para": "Our Liver Detox IV formula contains scientifically-proven ingredients to support liver health:",
            "items": [
                {
                    "title": "Glutathione",
                    "desc": "The body's master antioxidant that plays a crucial role in liver detoxification.",
                    "icon": "fa-solid fa-shield-virus"
                },
                {
                    "title": "B-Complex Vitamins",
                    "desc": "Essential for liver metabolism and energy production processes.",
                    "icon": "fa-solid fa-brain"
                },
                {
                    "title": "Magnesium",
                    "desc": "Supports liver enzyme function and helps eliminate toxins.",
                    "icon": "fa-solid fa-atom"
                },
                {
                    "title": "Zinc",
                    "desc": "Critical for liver regeneration and antioxidant protection.",
                    "icon": "fa-solid fa-shield-halved"
                }
            ]
        },
        "eligibility": {
            "heading": "Who Can Benefit?",
            "subheading": "Ideal candidates for Liver Detox IV Therapy",
            "para": "Liver Detox IV therapy is safe and effective for most adults, especially beneficial for those experiencing:",
            "items": [
                {
                    "title": "Chronic Fatigue",
                    "desc": "Individuals suffering from persistent tiredness or low energy levels.",
                    "icon": "fa-solid fa-cloud"
                },
                {
                    "title": "Toxin Exposure",
                    "desc": "People regularly exposed to pollution, chemicals, or alcohol.",
                    "icon": "fa-solid fa-biohazard"
                },
                {
                    "title": "Poor Nutrition",
                    "desc": "Those with unhealthy eating habits or nutrient deficiencies.",
                    "icon": "fa-solid fa-utensils"
                },
                {
                    "title": "Skin Concerns",
                    "desc": "Individuals seeking clearer, healthier-looking skin.",
                    "icon": "fa-solid fa-face-smile"
                }
            ]
        },
        "preparationTips": {
            "heading": "Preparation Guidelines",
            "subheading": "How to prepare for your Liver Detox IV session",
            "para": "Follow these simple steps to maximize the benefits of your treatment:",
            "items": [
                {
                    "title": "Stay Hydrated",
                    "desc": "Drink plenty of water before your session to support vein accessibility and detoxification.",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "Eat Light",
                    "desc": "Have a light, healthy snack beforehand to maintain stable blood sugar levels.",
                    "icon": "fa-solid fa-apple-whole"
                },
                {
                    "title": "Avoid Toxins",
                    "desc": "Refrain from alcohol and processed foods for 24 hours prior to treatment.",
                    "icon": "fa-solid fa-ban"
                },
                {
                    "title": "Medical Disclosure",
                    "desc": "Share your complete medical history and current medications with our team.",
                    "icon": "fa-solid fa-file-medical"
                }
            ]
        },
        "results": {
            "heading": "Expected Results",
            "subheading": "What to expect after your Liver Detox IV Drip",
            "para": "Patients typically experience multiple health benefits from this targeted therapy:",
            "items": [
                {
                    "title": "Energy Boost",
                    "desc": "Increased vitality and mental clarity within hours to days after treatment.",
                    "icon": "fa-solid fa-battery-full"
                },
                {
                    "title": "Improved Skin",
                    "desc": "Clearer complexion with better texture and tone as toxins are eliminated.",
                    "icon": "fa-solid fa-spa"
                },
                {
                    "title": "Better Digestion",
                    "desc": "Reduced bloating and improved digestive function from a cleaner liver.",
                    "icon": "fa-solid fa-stomach"
                },
                {
                    "title": "Overall Wellbeing",
                    "desc": "Enhanced resilience and balanced body function over time with regular sessions.",
                    "icon": "fa-solid fa-heart-circle-plus"
                }
            ]
        },
        "faqData": {
            "heading": "Frequently Asked Questions",
            "subheading": "Common questions about Liver Detox IV Therapy",
            "items": [
                {
                    "question": "How often should I get a Liver Detox IV Drip?",
                    "answer": "For optimal results, we recommend starting with 1-2 sessions per week for 3-4 weeks, then monthly maintenance sessions. Your practitioner will customize a plan based on your needs."
                },
                {
                    "question": "Is the treatment painful?",
                    "answer": "Most patients experience minimal discomfort - just a small pinch during IV insertion. The treatment itself is relaxing and pain-free."
                },
                {
                    "question": "How quickly will I see results?",
                    "answer": "Many patients report feeling more energetic within hours. Full benefits typically develop over several days as toxins are processed and eliminated."
                },
                {
                    "question": "Are there any side effects?",
                    "answer": "Side effects are rare but may include mild bruising at the injection site or temporary fatigue as your body processes toxins. These resolve quickly."
                },
                {
                    "question": "Can I combine this with other detox methods?",
                    "answer": "Yes, our Liver Detox IV complements other detox approaches like clean eating, exercise, and sauna therapy. We can create a comprehensive detox plan for you."
                },
                {
                    "question": "Is this treatment safe for everyone?",
                    "answer": "While generally safe, we recommend consulting with our medical team if you have severe liver conditions or are pregnant. We customize each treatment based on health history."
                }
            ]
        }
    },
    "ar": {
        "url": "liver-detox-iv-drip",
        "meta": {
            "title": "علاج التنقيط الوريدي لتنظيف الكبد من السموم في دبي | إيليت بودي هوم",
            "description": "دعم عملية إزالة السموم الطبيعية للكبد مع علاج التنقيط الوريدي لتنظيف الكبد من السموم في دبي. يوفر هذا العلاج المتخصص العناصر الغذائية الأساسية مباشرة إلى مجرى الدم لتحسين وظائف الكبد والصحة العامة.",
            "robots": "index, follow",
            "canonical": "https://elitebodyhome.com/services/liver-detox-iv-drip-in-dubai/",
            "og": {
                "title": "علاج التنقيط الوريدي لتنظيف الكبد من السموم في دبي | إيليت بودي هوم",
                "description": "دعم عملية إزالة السموم الطبيعية للكبد مع علاج التنقيط الوريدي لتنظيف الكبد من السموم في دبي. يوفر هذا العلاج المتخصص العناصر الغذائية الأساسية مباشرة إلى مجرى الدم.",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/liver-detox-iv.jpg"
            }
        },
        "breadcrumbs": ["الرئيسية", "الخدمات", "التنقيط الوريدي لتنظيف الكبد"],
        "hero": {
            "title": "علاج التنقيط الوريدي لتنظيف الكبد من السموم في دبي",
            "subtitle": "نظف، أنعش، واستعد الصحة!",
            "description": "يُعد الكبد من أهم الأعضاء المسؤولة عن إزالة السموم من الجسم، ومعالجة العناصر الغذائية، وتفكيك المواد الضارة. ولكن في ظل أنماط الحياة المزدحمة، والأنظمة الغذائية غير الصحية، والتعرض المستمر للسموم البيئية، قد يصبح الكبد مثقل بالسموم ويفقد قدرته على العمل بكفاءة. صُمم علاجنا الوريدي لتنظيف الكبد خصيصًا لدعم عملية إزالة السموم الطبيعية للكبد، وتعويض العناصر الغذائية الأساسية، وتعزيز الوظائف المثلى للكبد لتحسين الصحة والحيوية."
        },
        "howItWorks": {
            "title": "ما هو العلاج الوريدي لتنظيف الكبد؟",
            "description": "العلاج الوريدي لتنظيف الكبد هو علاج متخصص مصمم لدعم العمليات الطبيعية لإزالة السموم من الكبد. يحتوي المحلول الوريدي على مزيج قوي من فيتامينات ب المركبة، المعادن (المغنيسيوم، الزنك)، ومضادات الأكسدة القوية مثل الجلوتاثيون التي تعمل معًا لتعزيز وظائف الكبد، وتحفيز التخلص من السموم، واستعادة الصحة المثلى."
        },
        "procedureSteps": {
            "heading": "خطوات علاج التنقيط الوريدي لتنظيف الكبد",
            "para": "هذا الإجراء البسيط في العيادات الخارجية يوفر العناصر الغذائية المزيلة للسموم مباشرة في مجرى الدم لأقصى امتصاص وفعالية.",
            "steps": [
                {
                    "title": "الاستشارة",
                    "desc": "يقوم مقدم الرعاية الصحية بمراجعة تاريخك الطبي واحتياجاتك الصحية الخاصة بالكبد لتخصيص العلاج لك.",
                    "icon": "fa-solid fa-comment-medical"
                },
                {
                    "title": "التحضير",
                    "desc": "يتم تحضير المحلول الوريدي بمزيج مخصص من الفيتامينات، المعادن ومضادات الأكسدة حسب احتياجاتك.",
                    "icon": "fa-solid fa-flask"
                },
                {
                    "title": "التنفيذ",
                    "desc": "يتم إدخال إبرة صغيرة في الوريد لتوصيل المحلول المزيل للسموم مباشرة إلى مجرى الدم.",
                    "icon": "fa-solid fa-syringe"
                },
                {
                    "title": "المتابعة",
                    "desc": "يتم مراقبة العلامات الحيوية وراحتك طوال مدة الجلسة التي تستغرق 30-60 دقيقة من قبل فريقنا الطبي.",
                    "icon": "fa-solid fa-heart-pulse"
                }
            ]
        },
        "benefits": {
            "heading": "فوائد التنقيط الوريدي لتنظيف الكبد",
            "subheading": "استفد من الدعم الشامل للكبد وإزالة السموم",
            "para": "يعزز علاجنا الوريدي لتنظيف الكبد الصحة العامة من خلال تحسين الترشيح الطبيعي للسموم في الكبد وتوفير العناصر الغذائية الأساسية.",
            "items": [
                {
                    "title": "تعزيز إزالة السموم",
                    "desc": "يساعد في التخلص من السموم المتراكمة في الكبد، مما يحسن كفاءة الترشيح.",
                    "icon": "fa-solid fa-recycle"
                },
                {
                    "title": "زيادة الطاقة",
                    "desc": "يحسن وظائف الكبد لإنتاج طاقة أفضل، ويقلل من التعب والخمول.",
                    "icon": "fa-solid fa-bolt"
                },
                {
                    "title": "بشرة أكثر نقاءً",
                    "desc": "يقلل من الالتهابات وتلف الجذور الحرة الذي يمكن أن يؤثر على صحة البشرة.",
                    "icon": "fa-solid fa-spa"
                },
                {
                    "title": "تقليل الالتهاب",
                    "desc": "يقلل من التعرض للسموم التي تساهم في الالتهاب المزمن في جميع أنحاء الجسم.",
                    "icon": "fa-solid fa-fire-extinguisher"
                }
            ]
        },
        "ingredients": {
            "heading": "المكونات الرئيسية",
            "subheading": "عناصر غذائية قوية لدعم الكبد وإزالة السموم",
            "para": "تحتوي تركيبتنا الوريدية لتنظيف الكبد على مكونات مثبتة علميًا لدعم صحة الكبد:",
            "items": [
                {
                    "title": "الجلوتاثيون",
                    "desc": "مضاد الأكسدة الرئيسي في الجسم الذي يلعب دورًا حاسمًا في إزالة سموم الكبد.",
                    "icon": "fa-solid fa-shield-virus"
                },
                {
                    "title": "فيتامينات ب المركبة",
                    "desc": "ضرورية لعملية التمثيل الغذائي في الكبد وعمليات إنتاج الطاقة.",
                    "icon": "fa-solid fa-brain"
                },
                {
                    "title": "المغنيسيوم",
                    "desc": "يدعم وظائف إنزيمات الكبد ويساعد في التخلص من السموم.",
                    "icon": "fa-solid fa-atom"
                },
                {
                    "title": "الزنك",
                    "desc": "ضروري لتجديد الكبد والحماية المضادة للأكسدة.",
                    "icon": "fa-solid fa-shield-halved"
                }
            ]
        },
        "eligibility": {
            "heading": "من يمكنه الاستفادة؟",
            "subheading": "المرشحون المثاليون للعلاج الوريدي لتنظيف الكبد",
            "para": "علاج التنقيط الوريدي لتنظيف الكبد آمن وفعال لمعظم البالغين، وخاصة المفيد لمن يعانون من:",
            "items": [
                {
                    "title": "الإرهاق المزمن",
                    "desc": "الأفراد الذين يعانون من التعب المستمر أو انخفاض مستويات الطاقة.",
                    "icon": "fa-solid fa-cloud"
                },
                {
                    "title": "التعرض للسموم",
                    "desc": "الأشخاص المعرضون بانتظام للتلوث، المواد الكيميائية، أو الكحول.",
                    "icon": "fa-solid fa-biohazard"
                },
                {
                    "title": "سوء التغذية",
                    "desc": "أولئك الذين لديهم عادات غذائية غير صحية أو نقص في العناصر الغذائية.",
                    "icon": "fa-solid fa-utensils"
                },
                {
                    "title": "مشاكل البشرة",
                    "desc": "الأفراد الذين يسعون للحصول على بشرة أكثر نقاءً وصحة.",
                    "icon": "fa-solid fa-face-smile"
                }
            ]
        },
        "preparationTips": {
            "heading": "إرشادات التحضير",
            "subheading": "كيف تستعد لجلسة العلاج الوريدي لتنظيف الكبد",
            "para": "اتبع هذه الخطوات البسيطة لتعظيم فوائد علاجك:",
            "items": [
                {
                    "title": "حافظ على الترطيب",
                    "desc": "اشرب الكثير من الماء قبل جلستك لدعم سهولة الوصول إلى الأوردة وعملية إزالة السموم.",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "تناول وجبة خفيفة",
                    "desc": "تناول وجبة خفيفة وصحية مسبقًا للحفاظ على مستويات السكر في الدم مستقرة.",
                    "icon": "fa-solid fa-apple-whole"
                },
                {
                    "title": "تجنب السموم",
                    "desc": "امتنع عن الكحول والأطعمة المصنعة لمدة 24 ساعة قبل العلاج.",
                    "icon": "fa-solid fa-ban"
                },
                {
                    "title": "الكشف الطبي",
                    "desc": "شارك تاريخك الطبي الكامل والأدوية الحالية مع فريقنا.",
                    "icon": "fa-solid fa-file-medical"
                }
            ]
        },
        "results": {
            "heading": "النتائج المتوقعة",
            "subheading": "ما يمكن توقعه بعد جلسة التنقيط الوريدي لتنظيف الكبد",
            "para": "يشعر المرضى عادةً بفوائد صحية متعددة من هذا العلاج المستهدف:",
            "items": [
                {
                    "title": "زيادة الطاقة",
                    "desc": "زيادة الحيوية والوضوح الذهني خلال ساعات إلى أيام بعد العلاج.",
                    "icon": "fa-solid fa-battery-full"
                },
                {
                    "title": "تحسن البشرة",
                    "desc": "بشرة أكثر نقاءً مع تحسن الملمس واللون مع التخلص من السموم.",
                    "icon": "fa-solid fa-spa"
                },
                {
                    "title": "تحسن الهضم",
                    "desc": "تقليل الانتفاخ وتحسين وظيفة الجهاز الهضمي من كبد أنظف.",
                    "icon": "fa-solid fa-stomach"
                },
                {
                    "title": "تحسن عام في الصحة",
                    "desc": "تحسن القدرة على التحمل ووظائف الجسم المتوازنة مع الجلسات المنتظمة.",
                    "icon": "fa-solid fa-heart-circle-plus"
                }
            ]
        },
        "faqData": {
            "heading": "الأسئلة الشائعة",
            "subheading": "أسئلة متداولة حول العلاج الوريدي لتنظيف الكبد",
            "items": [
                {
                    "question": "كم مرة يجب أن أحصل على جلسة التنقيط الوريدي لتنظيف الكبد؟",
                    "answer": "للحصول على أفضل النتائج، نوصي بالبدء بجلسة إلى جلستين أسبوعيًا لمدة 3-4 أسابيع، ثم جلسات شهرية للصيانة. سيخصص لك الممارس خطة بناءً على احتياجاتك."
                },
                {
                    "question": "هل العلاج مؤلم؟",
                    "answer": "يشعر معظم المرضى بعدم ارتياح بسيط - مجرد وخزة صغيرة أثناء إدخال الوريد. العلاج نفسه مريح وخالٍ من الألم."
                },
                {
                    "question": "ما هي سرعة ظهور النتائج؟",
                    "answer": "يبلغ العديد من المرضى عن شعورهم بمزيد من الطاقة خلال ساعات. تتطور الفوائد الكاملة عادة على مدار عدة أيام مع معالجة السموم والتخلص منها."
                },
                {
                    "question": "هل هناك أي آثار جانبية؟",
                    "answer": "الآثار الجانبية نادرة ولكن قد تشمل كدمات طفيفة في موقع الحقن أو التعب المؤقت أثناء معالجة الجسم للسموم. تختفي هذه الآثار بسرعة."
                },
                {
                    "question": "هل يمكنني الجمع بين هذا العلاج وطرق إزالة السموم الأخرى؟",
                    "answer": "نعم، يتكامل علاجنا الوريدي لتنظيف الكبد مع طرق إزالة السموم الأخرى مثل الأكل الصحي، التمارين، وعلاج الساونا. يمكننا وضع خطة شاملة لإزالة السموم لك."
                },
                {
                    "question": "هل هذا العلاج آمن للجميع؟",
                    "answer": "بينما يعتبر آمنًا بشكل عام، نوصي باستشارة فريقنا الطبي إذا كنت تعاني من حالات كبدية شديدة أو كنت حاملاً. نخصص كل علاج بناءً على التاريخ الصحي."
                }
            ]
        }
    },
    "shared": {
        "images": {
            "main": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/New-Service-Banner-Idfmage-scaled.jpg",
            "beforeAfter": [

            ]
        },
        "product": {
            "id": 36,
            "title": "Liver Detox IV Drip Treatment",
            "description": "Specialized intravenous therapy delivering liver-supporting nutrients and antioxidants directly to your bloodstream for enhanced detoxification and improved liver function.",
            "price": 599
        }
    }
}